class AnimationService {
    /**
     * fade: Fades elements in or out
     * @param transition    string: the transition class to be used (e.g. vuw-transition-400)
     * @param selector      string: string to find element by (e.g. a class => .classname)
     * @param fadeIn        boolean: boolean to determine if the element fades in or out
     */
    fade(transition: string, selector:string, fadeIn: boolean = true):void {
        var element = document.querySelector(selector) as HTMLElement;

        if (!element) {
            return;
        }

        var start = 'vuw-opacity-0';
        var end = 'vuw-opacity-1';

        if (!fadeIn) {
            start = 'vuw-opacity-1';
            end = 'vuw-opacity-0';
        }
        element.classList.add(start);

        setTimeout(() => {
            element.classList.remove(start);
            element.classList.add(transition, end);
        }, 10);

        setTimeout(() => {
            element.classList.remove(transition, end, start);
        }, 450);
    }

    /**
     * rotate: Rotates an element backwards or forwards
     * @param selector  string: string to find element by (e.g. a class => .classname)
     * @param back      boolean: to determine whether the direction is forwards or backwards
     */
    rotate(selector: string, back: boolean = true):void {
        var element = document.querySelector(selector) as HTMLElement;
        var rotateClass = 'vuw-180-neg';

        if (!back) {
            rotateClass = 'vuw-180';
        }

        if(element) {
            element.classList.add('vuw-rotate', rotateClass);

            if(selector === ".plus-minus-icon") {
                setTimeout(() => {
                    element.classList.remove("fa-plus");
                    element.classList.add("fa-minus");
                }, 500);
            }

            setTimeout(() => {
                element.classList.remove('vuw-rotate', rotateClass);
            }, 1000);
        }
    }
}

export default new AnimationService()
